// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportDesignerContent.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * ReportDesignerContent component
 */
import connect from 'share/enhancers/Izenda.Connect';
import { observe } from 'mobx';
import React, { Component } from 'react';
import { onlyUpdateForKeys } from 'recompose';
import actions from './Izenda.ReportDesignerContentActions';
import MiddlePanel from 'share/components/layout/Izenda.MiddlePanel';
import ReportDesignerToolBar from './Izenda.ReportDesignerToolBar';
import uiState from 'logic/Izenda.UiState.js';
import OverlayContainer from 'share/components/hoc/Izenda.OverlayContainer';
import ReportDesignerDataSourceOverlay from './Izenda.ReportDesignerDataSourceOverlay';
import Constants from 'logic/data/Izenda.ReportDesignerConstants';
import BrowserUtils from 'share/utils/Izenda.BrowserUtils';

const MIN_WIDTH = 0;

@connect({ toClass: true }, onlyUpdateForKeys(['pageName', 'isNewReport']), actions)
export default class ReportDesignerContent extends Component {
  constructor(props: any) {
    super(props);
    const { store, pageInfo } = props;
    pageInfo.setStore(store);
    props.registerUpdateResultFuntion(props.onUpdateResults.bind(this));
  }

  componentWillReceiveProps(nextProps: any) {
    const { store, pageInfo, pageName } = nextProps;
    var isPageChanged = pageName !== this.props.pageName;

    if (isPageChanged) {
      pageInfo.setStore(store);
      pageInfo.reloadView && pageInfo.reloadView();
      store.validateReportId(false);
    }
  }

  componentDidMount() {
    const props = this.props;
    const model = props.store.model;
    const handleErrorMessages = props.handleErrorMessages;

    // Observe change selected item in data source tree
    this.dispose = observe(model, 'hasSelectedDataSource', change => {
      props.menuStore.updateMenuState(change);
    });

    // Observe error messages from child pages
    this.disposeErrorMessages = observe(model, 'errorMessages', handleErrorMessages);
    props.store.validateReportId(false);

    // observe schedule tab with global report
    model.isGlobal && props.menuStore.toggleInvisibleItem('Schedule', !model.isGlobal);
    this.disposeScheduleTab = observe(model, 'isGlobal', value => {
      props.menuStore.toggleInvisibleItem('Schedule', !value);
    });
  }

  componentWillUnmount() {
    const { pageInfo } = this.props;
    pageInfo.destroy && pageInfo.destroy();

    this.dispose && this.dispose();

    this.disposeErrorMessages();

    uiState.enableSystemSetting();

    this.disposeScheduleTab();
  }

  render() {
    const props = this.props;
    const { store, fieldsStore, pageName, pageInfo } = props;
    const onUpdateResults = props.onUpdateResults;
    const onAddReportPart = props.onAddReportPart;
    const onSave = props.onSave;
    const location = props.location;
    const onSaveAs = props.onSaveAs;
    const onCancelReport = props.onCancelReport;
    const onPreview = props.onPreview;
    const middlePanel = pageInfo.renderMiddlePanel ? pageInfo.renderMiddlePanel() : null;
    const mainPanel = pageInfo.renderMainContent();
    const doesShowOverlay =
      pageName === Constants.PAGE_NAME.DATA_SOURCE && store.isEnableOverlay && !BrowserUtils.isMobileDevice();

    return (
      <section className="izenda-ReportDesigner izenda-TableLayout">
        {/* middle panel */}
        {middlePanel && (
          <MiddlePanel minWidth={MIN_WIDTH} hidden={store.disabled}>
            {middlePanel}
          </MiddlePanel>
        )}
        {/* main content */}
        {/* get size of this */}
        <div className="izenda-TableLayout-Cell" hidden={store.disabled}>
          <OverlayContainer
            showOverlay={doesShowOverlay}
            classNames="izenda-Wrapper"
            OverlayComponent={ReportDesignerDataSourceOverlay}
            overlayComponentProps={{ classNames: 'izenda-ReportDesigner-Overlay' }}
          >
            <section className="izenda-Wrapper">
              <ReportDesignerToolBar
                showUpdateResult={props.showUpdateResult}
                store={store}
                fieldsStore={fieldsStore}
                pageName={pageName}
                onUpdateResults={onUpdateResults}
                onAddReportPart={onAddReportPart}
                onSave={onSave}
                onSaveAs={onSaveAs}
                location={location}
                onCancelReport={onCancelReport}
                onPreview={onPreview}
              />
              {mainPanel}
            </section>
          </OverlayContainer>
        </div>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Izenda.ReportDesignerContent.js